import { RefObject, useEffect } from 'react';
import { isMobile } from 'react-device-detect';

interface IsWithinVisibleViewportArgs {
  target: Element;
  visualViewport: VisualViewport;
}

const isWithinVisibleViewport = ({ target, visualViewport }: IsWithinVisibleViewportArgs) => {
  const { top: targetTop, bottom: targetBottom } = target.getBoundingClientRect();
  const { scrollMarginTop, scrollMarginBottom } = getComputedStyle(target);
  const { offsetTop, height } = visualViewport;

  const visibleTop = offsetTop + parseFloat(scrollMarginTop);
  const visibleBottom = offsetTop + height - parseFloat(scrollMarginBottom);

  return targetTop >= visibleTop && targetBottom <= visibleBottom;
};

export const useKeepMobileFieldAboveKeyboard = (containerRef: RefObject<HTMLElement>) => {
  useEffect(() => {
    const { visualViewport } = window;

    if (!isMobile || !visualViewport) {
      return;
    }

    const keepFieldAboveKeyboard = () => {
      const { current: container } = containerRef;

      if (!container?.contains(document.activeElement)) {
        return;
      }

      if (isWithinVisibleViewport({ target: container, visualViewport })) {
        return;
      }

      container.scrollIntoView({ block: 'nearest' });
    };

    visualViewport.addEventListener('resize', keepFieldAboveKeyboard);
    document.addEventListener('focusin', keepFieldAboveKeyboard);

    return () => {
      visualViewport.removeEventListener('resize', keepFieldAboveKeyboard);
      document.removeEventListener('focusin', keepFieldAboveKeyboard);
    };
  }, [containerRef]);
};
